import { useMutation } from '@tanstack/react-query';

import { ValidationTypeFormSchemaValues } from 'src/features/validationTypes/utils/formSchema';
import { ValidationType } from 'src/features/validationTypes/utils/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/validations/validation-type/:id/`;

type MutationFnType = typeof mutationFn;

interface DTO extends ValidationTypeFormSchemaValues {
    id: string;
    parkingId: string;
}
const mutationFn = ({ id, parkingId, ...data }: DTO): Promise<ValidationType> => {
    return axios.patch(formatResourcePath(RESOURCE, { id, parkingId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateValidationType };
